"use client";

import { Button, ConfigProvider } from "antd";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import MenuDrawerComponent from "./TheMenuDrawer";
import TheMenu from "./TheMenu";
import Link from "next/link";

const HeaderComponent = ({ menuItems }) => {
  const router = useRouter();
  const [openMenu, setOpenMenu] = useState(false);

  const [isScrolled, setIsScrolled] = useState(false);

  const googleTranslateElementInit = () => {
    if (window.google?.translate?.TranslateElement) {
      window.google.translate.TranslateElement(
        { pageLanguage: "vi" },
        "google_translate_element",
      );
    }
  };

  useEffect(() => {
    const scriptId = "google-translate-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    }

    const checkScript = setInterval(() => {
      if (window.google?.translate?.TranslateElement) {
        googleTranslateElementInit();
        clearInterval(checkScript);
      }
    }, 100);

    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearInterval(checkScript);
    };
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {},
      }}
    >
      <div
        id="main-menu"
        className="relative bg-no-repeat bg-scroll bg-cover"
        style={{ boxShadow: "0px 0px 12px 0px #60626629" }}
      >
        <div
          className={`
        mx-auto w-full max-w-[1290px] relative px-2 md:px-12 transition-all duration-300 ease-in-out
        ${
          isScrolled
            ? "md:py-[10px] py-2"
            : "md:py-[20px] py-4"
        }
      `}
        >
          <div className="flex w-full items-center justify-between">
            <button
              type="button"
              onClick={() => {
                router.push("/");
              }}
              className="flex-shrink-0 cursor-pointer"
            >
              <img
                alt="logo"
                className="logo h-[40px] object-cover"
                src="/images/logo.png"
              />
            </button>
            {/* Thu gọn menu từ màn 1024px trở xuống (<= lg), hiển thị hamburger */}
            <div className="lg:hidden flex">
              <button onClick={() => setOpenMenu(true)}>
                <img
                  src={"/svg/menu.svg"}
                  alt="menu"
                  width={30}
                  height={30}
                  className="filter-white"
                />
              </button>
            </div>
            {/* Trên 1024px hiển thị menu ngang */}
            <div className="lg:block hidden">
              <TheMenu menuItems={menuItems} className="" />
            </div>
            {/* <div className="md:flex hidden gap-2 ml-auto items-center">
              <div id="google_translate_element" className="goog-te-gadget">
                <style>{`
                .goog-te-gadget {
                 height: 44px;
                 overflow: hidden
                }
                .goog-te-gadget span {
                 display: none}
                  .goog-te-gadget {
                    font-family: "Roboto", sans-serif;
                  }
                  .goog-te-gadget-simple {
                    background-color: transparent !important;
                    border: none !important;
                    padding: 0 !important;
                  }
                  .goog-te-gadget-icon {
                    background-image: none !important;
                    display: none !important;
                  }
                  .goog-te-combo {
                  width: 160px;
                    background-color: #f5f5f5 !important;
                    border: 1px solid #e0e0e0 !important;
                    border-radius: 6px !important;
                    padding: 8px 12px !important;
                    font-size: 14px !important;
                    color: #333 !important;
                    cursor: pointer !important;
                    transition: all 0.3s ease !important;
                  }
                  .goog-te-combo:hover {
                    border-color: #E5C383 !important;
                    background-color: #fff !important;
                  }
                `}</style>
              </div>
              <Link href={`/lien-he#tu-van`}>
                <Button
                  size="large"
                  shape="round"
                  type="primary"
                  className="!py-4 !px-10 !h-[50px] !text-black !font-semibold"
                >
                  <span>Tư vấn ngay</span>
                </Button>
              </Link>
            </div> */}
          </div>
        </div>
        <MenuDrawerComponent
          menuItems={menuItems}
          open={openMenu}
          setClose={setOpenMenu}
        />
      </div>
    </ConfigProvider>
  );
};

export default HeaderComponent;
